// extracted by mini-css-extract-plugin
module.exports = {"labeledInput":"styles_labeledInput__VIWyr","label":"styles_label__2n1sG"};